var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.8525,
    cy: 71.8534,
    r: 71.5087,
    fill: "#EDF1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3475 102.398C98.8604 101.898 99.1478 101.211 99.1438 100.495C99.1399 99.1097 98.0918 97.9502 96.7141 97.8079H96.7002C96.6152 97.7966 96.5295 97.792 96.4438 97.7947H77.5438C77.4581 97.792 77.3724 97.7966 77.2874 97.8079H77.2735C76.6546 97.8711 76.0771 98.148 75.6401 98.591C75.1272 99.0913 74.8398 99.7781 74.8438 100.495C74.8484 101.984 76.0547 103.19 77.5438 103.195H78.8938C77.4073 103.206 76.205 104.408 76.1938 105.895C76.1984 107.384 77.4047 108.59 78.8938 108.595C78.8938 111.577 81.3117 113.995 84.2938 113.995H89.6938C92.6759 113.995 95.0938 111.577 95.0938 108.595C96.5803 108.583 97.7826 107.381 97.7938 105.895C97.7892 104.406 96.5829 103.199 95.0938 103.195H96.4438C97.1603 103.199 97.8472 102.911 98.3475 102.398Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.893 38.3948V46.4948H35.6934V38.3948C35.698 36.9057 36.9043 35.6994 38.3934 35.6948H103.193C104.682 35.6994 105.889 36.9057 105.893 38.3948Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0437 103.195V47.8447H104.544V57.2947H107.244V38.3947C107.244 36.1581 105.43 34.3447 103.194 34.3447H38.3937C36.1572 34.3447 34.3438 36.1581 34.3438 38.3947V103.195C34.3438 105.431 36.1572 107.245 38.3937 107.245H72.1437V104.545H38.3937C37.6482 104.545 37.0437 103.94 37.0437 103.195ZM38.3937 37.0447H103.194C103.939 37.0447 104.544 37.6492 104.544 38.3947V45.1447H37.0437V38.3947C37.0437 37.6492 37.6482 37.0447 38.3937 37.0447Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4434 39.7446H45.1434V42.4446H42.4434V39.7446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8438 39.7446H50.5437V42.4446H47.8438V39.7446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2441 39.7446H55.9441V42.4446H53.2441V39.7446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4434 53.2446H45.1434V55.9446H42.4434V53.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8438 53.2446H50.5437V55.9446H47.8438V53.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2441 53.2446H55.9441V55.9446H53.2441V53.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6445 53.2446H61.3445V55.9446H58.6445V53.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.043 39.7446H93.743V42.4446H64.043V39.7446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6445 53.2446H88.3445V58.6446H85.6445V53.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.268 64.4112L106.086 60.5933L107.995 62.5022L104.177 66.3209L102.268 64.4112Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.943 80.2446H115.343V82.9446H109.943V80.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.268 98.7771L104.177 96.8682L107.995 100.686L106.086 102.595L102.268 98.7771Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9922 100.686L69.8108 96.8672L71.7198 98.7768L67.9018 102.595L65.9922 100.686Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6445 80.2446H64.0445V82.9446H58.6445V80.2446Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9922 62.5022L67.9018 60.5933L71.7198 64.4112L69.8108 66.3209L65.9922 62.5022Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.244 81.5944C107.243 72.1003 100.646 63.881 91.3766 61.8256C82.1072 59.771 72.6545 64.432 68.6415 73.0363C64.6284 81.6412 67.1326 91.8783 74.6644 97.6593C73.8009 98.5288 73.3803 99.7436 73.5207 100.96C73.6604 102.178 74.3467 103.265 75.3849 103.916C74.7731 104.968 74.6749 106.241 75.1172 107.375C75.5602 108.509 76.4956 109.379 77.6584 109.738C78.2141 112.971 81.0136 115.336 84.2937 115.344H89.6937C92.9757 115.335 95.7759 112.967 96.329 109.731C97.4918 109.372 98.4278 108.502 98.8708 107.368C99.3137 106.235 99.2155 104.961 98.6038 103.908C99.642 103.258 100.328 102.171 100.468 100.954C100.608 99.737 100.188 98.5222 99.3243 97.6527C104.337 93.838 107.268 87.8929 107.244 81.5944ZM96.4437 99.1444C97.1892 99.1444 97.7937 99.7489 97.7937 100.494C97.7937 101.24 97.1892 101.844 96.4437 101.844H77.5437C76.7981 101.844 76.1937 101.24 76.1937 100.494C76.1937 99.7489 76.7981 99.1444 77.5437 99.1444H96.4437ZM89.6937 112.644H84.2937C82.5838 112.637 81.0624 111.557 80.4922 109.944H93.4952C92.925 111.557 91.4036 112.637 89.6937 112.644ZM95.0937 107.244H78.8937C78.1481 107.244 77.5437 106.64 77.5437 105.894C77.5437 105.149 78.1481 104.544 78.8937 104.544H95.0937C95.8392 104.544 96.4437 105.149 96.4437 105.894C96.4437 106.64 95.8392 107.244 95.0937 107.244ZM96.3151 96.4444H88.3437V84.2944H92.3937C94.6303 84.2944 96.4437 82.481 96.4437 80.2444C96.4437 78.0078 94.6303 76.1944 92.3937 76.1944C90.1571 76.1944 88.3437 78.0078 88.3437 80.2444H91.0437C91.0437 79.4989 91.6481 78.8944 92.3937 78.8944C93.1392 78.8944 93.7437 79.4989 93.7437 80.2444C93.7437 80.99 93.1392 81.5944 92.3937 81.5944H81.5937C80.8481 81.5944 80.2437 80.99 80.2437 80.2444C80.2437 79.4989 80.8481 78.8944 81.5937 78.8944C82.3392 78.8944 82.9437 79.4989 82.9437 80.2444H85.6437C85.6437 78.0078 83.8303 76.1944 81.5937 76.1944C79.3571 76.1944 77.5437 78.0078 77.5437 80.2444C77.5437 82.481 79.3571 84.2944 81.5937 84.2944H85.6437V96.4444H77.6788C71.0488 92.2883 67.9717 84.245 70.1338 76.7251C72.2959 69.2052 79.1758 64.0247 87.0003 64.0247C94.8254 64.0247 101.705 69.2052 103.867 76.7251C106.029 84.245 102.952 92.2883 96.3224 96.4444H96.3151Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4434 58.6445H61.3434V61.3445H42.4434V58.6445Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4434 64.0449H61.3434V66.7449H42.4434V64.0449Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4434 69.4448H61.3434V72.1448H42.4434V69.4448Z",
    fill: "#4C6FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white",
    transform: "translate(34.3438 34.3447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroFunnel);
export default __webpack_public_path__ + "static/media/zero_funnel.38f41a8f4b110961b1a5ac0467914748.svg";
export { ForwardRef as ReactComponent };